export default __webpack_public_path__ + "static/media/1.a1300d67.PNG";